"use client";

import { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { registerUser } from "../../../api/api";

const SignUpForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      const data = await registerUser(name, email, password);
      setSuccess("Account created successfully! Redirecting to login...");
      setTimeout(() => navigate("/"), 2000);
    } catch (err) {
      setError(err.message || "Registration failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-main-content">
      <Row className="g-0 min-vh-100">
        {/* Left side full image */}
        <Col lg={6} className="d-none d-lg-flex"
          style={{
            backgroundImage: 'url("/images/signin.jpg")',
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            minHeight: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          {/* Dark Overlay */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(84, 82, 82, 0.5)",
            }}>

          </div>

          {/* Centered Text */}
          <div
            style={{
              position: "relative",
              zIndex: 2,
              color: "#ffffff",
              textAlign: "center",
              maxWidth: "80%",
            }}
          >
            <h1
              style={{
                fontWeight: "900",
                marginBottom: "20px",
                color: "#ffffff"
              }}
            >
              Time Sync
            </h1>
            <p style={{ fontSize: "24px" }}>
              Start Your Productivity Journey
            </p>
            <p style={{ fontSize: "20px" }}>
              Centralize projects, monitor progress, and boost team efficiency
            </p>
          </div>
        </Col>

        {/* Right side - sign up form */}
        <Col lg={6} className="d-flex align-items-center justify-content-center">
          <div className="mw-480 mx-auto w-100 px-4">
            <div className="mb-4 text-center w-100">
              <h3 className="fs-28 mb-4 text-center">Welcome Back </h3>

              <div className="row justify-content-center mb-4">
                <div className="col-lg-4 col-sm-4">
                  <a
                    href="https://www.google.com/"
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-outline-secondary bg-transparent w-100 py-2 hover-bg"
                    style={{ borderColor: "#D6DAE1" }}
                  >
                    <img src="/images/google.svg" alt="google" width={25} height={25} />
                  </a>
                </div>
                <div className="col-lg-4 col-sm-4">
                  <a
                    href="https://www.facebook.com/"
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-outline-secondary bg-transparent w-100 py-2 hover-bg"
                    style={{ borderColor: "#D6DAE1" }}
                  >
                    <img src="/images/facebook2.svg" alt="facebook2" width={25} height={25} />
                  </a>
                </div>
                <div className="col-lg-4 col-sm-4">
                  <a
                    href="https://www.apple.com/"
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-outline-secondary bg-transparent w-100 py-2 hover-bg"
                    style={{ borderColor: "#D6DAE1" }}
                  >
                    <img src="/images/apple.svg" alt="apple" width={25} height={25} />
                  </a>
                </div>
              </div>
            </div>



            {error && <div className="alert alert-danger">{error}</div>}
            {success && <div className="alert alert-success">{success}</div>}

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <label className="label text-secondary">Full Name</label>
                <Form.Control
                  type="text"
                  className="h-55"
                  placeholder="Enter your full name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <label className="label text-secondary">Email Address</label>
                <Form.Control
                  type="email"
                  className="h-55"
                  placeholder="example@trezo.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <label className="label text-secondary">Password</label>
                <Form.Control
                  type="password"
                  className="h-55"
                  placeholder="Type password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <button
                  type="submit"
                  className="btn btn-primary fw-medium py-2 px-3 w-100"
                  disabled={loading}
                >
                  <div className="d-flex align-items-center justify-content-center py-1">
                    <span className="material-symbols-outlined fs-20 text-white me-2">
                      person_4
                    </span>
                    <span>{loading ? "Signing Up..." : "Sign Up"}</span>
                  </div>
                </button>
              </Form.Group>

              <Form.Group>
                <p>
                  By confirming your email, you agree to our{" "}
                  <Link
                    to="/terms-conditions"
                    className="fw-medium text-decoration-none"
                  >
                    Terms of Service
                  </Link>{" "}
                  and that you have read and understood our{" "}
                  <Link
                    to="/privacy-policy"
                    className="fw-medium text-decoration-none"
                  >
                    Privacy Policy
                  </Link>
                  .
                </p>

                <p>
                  Already have an account?{" "}
                  <Link
                    to="/"
                    className="fw-medium text-primary text-decoration-none"
                  >
                    Sign In
                  </Link>
                </p>
              </Form.Group>
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SignUpForm;
